



































import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'AccountCard'
})
export default class extends Vue {
  @Prop({ required: true }) title!: string
  @Prop({ required: true }) email!: string
  @Prop({ required: true }) id!: string | number
  @Prop({ required: true }) isUse!: number
  @Prop({ required: false }) methods!: string[]
}
